import '../sass/admin.scss';

wp.domReady(() => {
    wp.blocks.unregisterBlockStyle('core/image', 'rounded');
    wp.blocks.unregisterBlockStyle('core/image', 'default');
    wp.blocks.unregisterBlockStyle('core/quote', 'plain');
    wp.blocks.unregisterBlockStyle('core/quote', 'large');

    tinymce.PluginManager.add( 'wdd_mce_format', function ( editor, url ) {
        editor.addButton( 'wdd_mce_format', {
            active: true,
            tooltip: 'Formating the List',
            text : 'Formating the List',
            icon : false,
            type : 'button',
            onclick : function () {
                
            }
        } );
    } );
} );
